import axios from 'axios'

export default {
  namespaced: true,
  state: {
    exerciseId: null,
    owner: null,
    shortId: null,
    exerciseTitle: '',
    bots: [],
    answers: [],
    history: [],
    path: [],
    time: 0,
    recordings: [],
    currentBotId: null,
    backgroundStore: [],
    personStore: [],
    saving: false,
    saved: false,
    blockCopy: false,
    type: null,
    activePlayModes: null
  },
  mutations: {
    CHANGE_CURRENT_BOT: (state, id) => {
      state.currentBotId = id;
    },
    CLEAR_STATE: (state) => {
      state.exerciseId = null;
      state.owner = null;
      state.exerciseTitle = '';
      state.bots = [];
      state.answers = [];
      state.history = [];
      state.path = [];
      state.time = 0;
      state.recordings = [];
      state.currentBotId = null;
      state.saving = false;
      state.saved = false;
      state.dataLoaded = false;
      state.backgroundStore = [];
      state.personStore = [];
      state.blockCopy = false;
      state.type = null;
      state.activePlayModes = null;
    },
    LOAD_DATA: (state, data) => {
      state.exerciseId = data._id;
      state.owner = data.owner;
      state.shortId = data.shortId;
      state.exerciseTitle = data.title;
      state.bots = data.bots;
      state.answers = data.answers;
      state.currentBotId = data.bots[0].id;
      state.backgroundStore = data.backgroundStore;
      state.personStore = data.personStore;
      state.blockCopy = data.blockCopy;
      state.type = data.type;
      state.activePlayModes = data.activePlayModes;
    },
    NEXT_QUESTION: (state, { nextId, answerId }) => {
      state.history.push({ type: 'bot', id: state.currentBotId });
      state.history.push({ type: 'answer', id: answerId });
      state.currentBotId = nextId;
    },
    RESTART: (state) => {
      state.history = [];
      state.currentBotId = state.bots[0].id;
      state.path = [];
      state.time = 0;
      state.recordings = [];
      state.saved = false;
    },
    START_SAVING: (state) => {
      state.saving = true;
    },
    DONE_SAVING: (state) => {
      state.saving = false;
    },
    SET_SAVED: (state, payload) => {
      state.saved = payload;
    },
    ADD_TO_PATH: (state, answerId) => {
      state.path.push(answerId);
    },
    ADD_RECORDING: (state, {answerId, data, time}) => {
      let existingIndex = state.recordings.findIndex(record => {
        return record.answerId == answerId;
      })
      if(existingIndex > -1) {
        state.recordings[existingIndex] = {answerId, data};
      } else {
        state.recordings.push({answerId, data});
      }
      state.time += time;
    }
  },
  actions: {
    loadData: ({commit}, exerciseId) => {
      return new Promise((resolve, reject) => {
        axios({
          method: 'post',
          url: `${process.env.VUE_APP_SERVER_URL}playModeLoadExercise`,
          data: {
            exerciseId
          }
        }).then(result => {
          commit('LOAD_DATA', result.data.exercise);
          resolve();
        }).catch(err => {
          reject(err.response.data.error);
        })
      })
    },
    clear: ({commit}) => {
      commit('CLEAR_STATE');
    },
    nextQuestion: ({commit}, { nextId, answerId }) => {
      commit('NEXT_QUESTION', { nextId, answerId });
    },
    restart: ({commit}) => {
      commit('RESTART');
    },
    saveDialog: ({commit, state}, name) => {
      commit('START_SAVING');
      return new Promise((resolve, reject) => {
        if(state.saved.type == 'draft') {
          axios({
            method: 'post',
            url: `${process.env.VUE_APP_SERVER_URL}saveDialog`,
            data: {
              draftId: state.saved.documentId,
              owner: name,
            }
          }).then(result => {
            commit('DONE_SAVING');
            commit('SET_SAVED', {type: 'save', documentId: result.data.documentId});
            resolve();
          }).catch(err => {
            commit('DONE_SAVING');
            reject(err.response.data.error);
            console.log(err.response.data.error);
          })
        } else {
          axios({
            method: 'post',
            url: `${process.env.VUE_APP_SERVER_URL}saveDialog`,
            data: {
              exerciseId: state.exerciseId,
              owner: name,
              path: state.path,
              time: state.time,
              recordings: state.recordings,
              mode: 'record',
            }
          }).then(result => {
            commit('DONE_SAVING');
            commit('SET_SAVED', {type: 'save', documentId: result.data.documentId});
            resolve();
          }).catch(err => {
            commit('DONE_SAVING');
            reject(err.response.data.error);
            console.log(err.response.data.error);
          })
        }
      })
    },
    saveDraft: ({commit, state}) => {
      commit('START_SAVING');
      return new Promise((resolve, reject) => {
        axios({
          method: 'post',
          url: `${process.env.VUE_APP_SERVER_URL}saveDialogDraft`,
          data: {
            exerciseId: state.exerciseId,
            path: state.path,
            time: state.time,
            recordings: state.recordings,
            mode: 'record',
          }
        }).then(result => {
          commit('DONE_SAVING');
          commit('SET_SAVED', {type: 'draft', documentId: result.data.documentId});
          resolve();
        }).catch(err => {
          commit('DONE_SAVING');
          reject(err.response.data.error);
          console.log(err.response.data.error);
        })
      })
    },
    addToPath: ({commit}, answerId) => {
      commit('ADD_TO_PATH', answerId);
    },
    addRecording: ({commit}, {answerId, data, time}) => {
      commit('ADD_RECORDING', {answerId, data, time});
    }
  },
  getters: {
    currentBotData: (state) => {
      return state.bots.filter(bot => {
        return bot.id === state.currentBotId;
      })
    },
    currentAnswers: (state) => {
      let current = state.bots.filter(bot => {
        return bot.id === state.currentBotId;
      })
      if(current.length != 0) {
        let answers = [];
        current[0].answers.forEach(answerId => {
          let answer = state.answers.filter(answer => {
            return answer.id === answerId
          })
          answers.push(answer[0]);
        });
        return answers;
      } else {
        return [];
      }
    },
    getTitle: (state) => {
      return state.exerciseTitle;
    },
    getShortId: (state) => {
      return state.shortId;
    },
    getHistory: (state) => {
      let array = [];
      state.history.forEach(element => {
        if(element.type == 'bot') {
          let bot = state.bots.find(bot => {
            return bot.id === element.id
          })
          element.text = bot.text;
          array.push(element);
        } else {
          let answer = state.answers.find(answer => {
            return answer.id === element.id
          })
          element.text = answer.text;
          array.push(element);
        }
      });
      return array;
    },
    getCurrentBotBg: (state) => {
      let currentBot = state.bots.filter(bot => {
        return bot.id === state.currentBotId;
      })
      return currentBot[0].background;
    },
    getCurrentBotPerson: (state) => {
      let currentBot = state.bots.filter(bot => {
        return bot.id === state.currentBotId;
      })
      return currentBot[0].person;
    },
    getCurrentBotAudioType: (state) => {
      let currentBot = state.bots.filter(bot => {
        return bot.id === state.currentBotId;
      })
      return currentBot[0].audioType;
    },
    getSavingState: (state) => {
      return state.saving;
    },
    getSaveState: (state) => {
      return state.saved;
    },
    getBackgroundStore: (state) => {
      return state.backgroundStore;
    },
    getPersonStore: (state) => {
      return state.personStore;
    },
    getExerciseId: (state) => {
      return state.exerciseId;
    },
    getOwner: (state) => {
      return state.owner;
    },
    checkIfBlockCopy: (state) => {
      return state.blockCopy;
    },
    getType: (state) => {
      return state.type;
    },
    getActivePlayModes: (state) => {
      return state.activePlayModes;
    }
  }
}